import Buttons from './Buttons.json';
import CineDialog from './CineDialog.json';
import Common from './Common.json';
import Header from './Header.json';
import Report from './Report';
import StudyBrowser from './StudyBrowser';
import StudyList from './StudyList.json';
import UserPreferencesModal from './UserPreferencesModal.json';
import ViewerTool from './ViewerTool';
import Vindoc from './Vindoc.js';

export default {
  vi: {
    Buttons,
    CineDialog,
    Common,
    Header,
    StudyList,
    UserPreferencesModal,
    ViewerTool,
    Vindoc,
    Report,
    StudyBrowser,
  },
};
